<template>
  <div
    class="custom-checkbox"
    :class="{ 'with-dropdown': items.length > 0, active: isActive }"
  >
    <div class="checkbox-container">
      <!-- Single label wrapping everything -->
      <div class="checkbox-wrapper">
        <input
          :id="'checkbox-' + id"
          type="checkbox"
          :checked="checked"
          :disabled="disabled"
          @click="(e) => checkboxClick(id, title)"
        />
        <!-- Inner label is for styling only -->
        <label :for="'checkbox-' + id" class="checkbox-style">
          <div class="tick_mark"></div>
        </label>
        <span class="checkbox-title">{{ title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "YearCheckBox",
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    checked: Boolean,
    disabled: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
    item_ids: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isActive: false,
      searchText: "",
    };
  },
  methods: {
    checkboxClick(id, name) {
      this.$emit("checkbox-click", id, name);
    },
    subCheckboxClick(id, name) {
      this.$emit("sub-checkbox-click", id, name);
    },
  },
};
</script>

<style scoped>
.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.checkbox-title {
  margin-left: 10px;
  font-size: 20px;
  cursor: pointer;
}

.checkbox-wrapper * {
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.checkbox-wrapper input[type="checkbox"] {
  display: none !important;
  visibility: hidden;
  position: absolute;
}

.checkbox-wrapper .checkbox-style {
  --size: 30px;
  --shadow: calc(var(--size) * 0.05) calc(var(--size) * 0.1);
  position: relative;
  display: block;
  width: var(--size);
  height: var(--size);
  margin: 0;
  background-color: #4158d0;
  background-image: linear-gradient(135deg, #5367ff, #00d09c);
  border-radius: 50%;
  cursor: pointer;
  transition: 0.2s ease transform, 0.2s ease background-color,
    0.2s ease box-shadow;
  overflow: hidden;
  z-index: 1;
}

.checkbox-wrapper .checkbox-style:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  width: calc(var(--size) * 0.7);
  height: calc(var(--size) * 0.7);
  margin: 0 auto;
  background-color: #fff;
  transform: translateY(-50%);
  border-radius: 50%;
  transition: 0.2s ease width, 0.2s ease height;
}

.checkbox-wrapper .checkbox-style:hover:before {
  width: calc(var(--size) * 0.55);
  height: calc(var(--size) * 0.55);
}

.checkbox-wrapper .checkbox-style:active {
  transform: scale(0.9);
}

.checkbox-wrapper .tick_mark {
  position: absolute;
  top: -1px;
  right: 0;
  left: calc(var(--size) * -0.05);
  width: calc(var(--size) * 0.6);
  height: calc(var(--size) * 0.6);
  margin: 0 auto;
  margin-left: calc(var(--size) * 0.14);
  transform: rotateZ(-40deg);
}

.checkbox-wrapper .tick_mark:before,
.checkbox-wrapper .tick_mark:after {
  content: "";
  position: absolute;
  background-color: #fff;
  border-radius: 2px;
  opacity: 0;
  transition: 0.2s ease transform, 0.2s ease opacity;
}

.checkbox-wrapper .tick_mark:before {
  left: 0;
  bottom: 0;
  width: calc(var(--size) * 0.1);
  height: calc(var(--size) * 0.3);
  transform: translateY(calc(var(--size) * -0.68));
}

.checkbox-wrapper .tick_mark:after {
  left: 0;
  bottom: 0;
  width: 100%;
  height: calc(var(--size) * 0.1);
  transform: translateX(calc(var(--size) * 0.78));
}

.checkbox-wrapper input[type="checkbox"]:checked + .checkbox-style {
  background-color: #4158d0;
  background-image: linear-gradient(135deg, #5367ff, #00d09c);
}

.checkbox-wrapper input[type="checkbox"]:checked + .checkbox-style:before {
  width: 0;
  height: 0;
}

.checkbox-wrapper
  input[type="checkbox"]:checked
  + .checkbox-style
  .tick_mark:before,
.checkbox-wrapper
  input[type="checkbox"]:checked
  + .checkbox-style
  .tick_mark:after {
  transform: translate(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/MultistepFormForFinder/YearCheckBox.vue